export default [
  {
    title: 'Sobre a Koin',
    text: `
      A Koin acredita que novas opções de pagamento e acesso ao crédito atendem às reais necessidades de consumidores e empresas. 
      </br>
      Por isso, eles desenvolvem soluções para realizar o propósito de melhorar a vida das pessoas, democratizando o acesso a bens e serviços. Sempre de maneira simples!
    `,
  },
  {
    title: 'O que é o pix parcelado?',
    text: `O Pix parcelado é uma forma de parcelamento que não exige cartão de crédito, você parcela suas compras usando apenas o Pix.`,
  },
  {
    title: 'Quais são as etapas de contratação?',
    text: `
      Após selecionar a sua oferta em nossa plataforma, você será direcionado para a contratação na plataforma da Koin. 
      <br />
      Depois disso, é só selecionar as parcelas do seu Pix e ir direto para as suas compras. 
    `,
  },
  {
    title: 'Qual a documentação necessária para contratar?',
    text: `Não é necessário enviar a sua documentação para a comprovação.`,
  },
  {
    title: `Qual a taxa de juros da Koin?`,
    text: `A Koin cobra uma taxa a partir de 3% ao mês.`,
  },
  {
    title: `Em quanto tempo consigo realizar a transação?`,
    text: `Em menos de 1 minuto é liberado para você seguir com o seu Pix parcelado.`,
  },
]
